export default "__VITE_ASSET__gTQCYJpA__"